import "./OverlayModal.css"

const OverlayModal = (props) => {
  return <div className="overlayModal" onClick={props.closeModalHandler} />
}
export default OverlayModal
